module.exports = __webpack_public_path__ + "img/advantages-bg--767.7e4a915.jpg";